document.addEventListener("DOMContentLoaded", function () {
    if (document.getElementById('glossary')) {
        const words = document.querySelectorAll(".word");
        words.forEach((word) => {
            word.addEventListener("click", function () {
                const icon = this.querySelector(".icon");
                const description = this.nextElementSibling;

                if (icon.classList.contains("icon--arrow_up")) {
                    icon.classList.remove("icon--arrow_up");
                    icon.classList.add("icon--arrow_down");
                    description.style.display = "block";
                } else {
                    icon.classList.remove("icon--arrow_down");
                    icon.classList.add("icon--arrow_up");
                    description.style.display = "none";
                }
            });
        });

        const glossary_search = document.getElementById("glossary_search");
        const dts = document.querySelectorAll("#glossary dt");
        const dds = document.querySelectorAll("#glossary dd");
        glossary_search.addEventListener("input", function () {
            const search_term = glossary_search.value.toLowerCase().trim();

            if (search_term === "") {
                dts.forEach((dt) => {
                    dt.style.display = "block";
                });

                dds.forEach((dd) => {
                    dd.style.display = "block";
                });
            } else {
                dts.forEach((dt) => {
                    dt.style.display = "none";
                });

                dds.forEach((dd) => {
                    const string_element = dd.querySelector(".string");

                    if (string_element) {
                        const text = string_element.textContent.toLowerCase();
                        if (text.includes(search_term)) {
                            dd.style.display = "block";
                        } else {
                            dd.style.display = "none";
                        }
                    }
                });
            }
        });
    }
});